import { render, staticRenderFns } from "./GlobalRatePostsInDiscover.vue?vue&type=template&id=7ee5dad2&scoped=true&"
import script from "./GlobalRatePostsInDiscover.vue?vue&type=script&lang=js&"
export * from "./GlobalRatePostsInDiscover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ee5dad2",
  null
  
)

export default component.exports